module.exports = "img/info.svg";